import { createFeatureSelector } from '@ngrx/store';

import { PublicInfoDataState } from './public-info.firestore.reducer';
import { FIRESTORE_COLLECTION_PUBLIC_INFO } from '@store/firestore/allFirestoreCollections';

export const publicInfoDataState = createFeatureSelector<PublicInfoDataState>(FIRESTORE_COLLECTION_PUBLIC_INFO);

export { PublicInfoDataState };
